import { useNavigate } from "react-router-dom";
import { festivalInfo } from "@/mocks/festival";

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-gradient-animate-dark text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-[1.4fr_1fr] gap-8 md:gap-12 max-w-6xl mx-auto">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-accent-500 text-white text-xl">
                <i className="ri-goblet-fill"></i>
              </span>
              <div>
                <strong className="block font-heading text-lg text-white">{festivalInfo.name}</strong>
                <span className="text-xs tracking-[0.18em] text-background-300">CHENAN IPJANG GRAPE FESTIVAL</span>
              </div>
            </div>
            <p className="mt-6 text-sm leading-relaxed text-background-200">
              {festivalInfo.dateText} · {festivalInfo.venue}
              <br />
              {festivalInfo.address}
            </p>
            <p className="mt-3 text-sm text-background-200">
              주최·주관 : {festivalInfo.organizer}
            </p>
          </div>

          <div className="flex flex-col gap-3">
            <span className="text-xs tracking-[0.2em] text-accent-300">QUICK LINK</span>
            <div className="flex flex-wrap gap-2">
              <button
                type="button"
                onClick={() => navigate("/")}
                className="cursor-pointer whitespace-nowrap rounded-full bg-white/10 px-4 py-2 text-sm text-white hover:bg-white/20 transition-colors"
              >
                축제 홈
              </button>
              <button
                type="button"
                onClick={() => navigate("/apply")}
                className="cursor-pointer whitespace-nowrap rounded-full btn-gradient-accent px-4 py-2 text-sm text-white"
              >
                수확체험 신청
              </button>
              <button
                type="button"
                onClick={() => navigate("/song")}
                className="cursor-pointer whitespace-nowrap rounded-full bg-white/10 px-4 py-2 text-sm text-white hover:bg-white/20 transition-colors"
              >
                가요제 신청
              </button>
              <a
                href="https://map.naver.com/p/search/입장초등학교"
                target="_blank"
                rel="noopener noreferrer"
                className="cursor-pointer whitespace-nowrap rounded-full bg-white/10 px-4 py-2 text-sm text-white hover:bg-white/20 transition-colors"
              >
                오시는 길
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 max-w-6xl mx-auto border-t border-white/15 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-300">
            COPYRIGHT © 2026 {festivalInfo.organizer}. ALL RIGHTS RESERVED.
          </p>
          <p className="text-xs text-background-300">
            본 페이지는 축제 안내를 위한 홈페이지입니다.
          </p>
        </div>
      </div>
    </footer>
  );
}